import { useSubscription } from '@/hooks/useSubscription';

// ─── Types ────────────────────────────────────────────────────────────────────

interface Props {
  pageContext?: 'stats' | 'taxes' | 'invoice' | 'general';
  onChoosePlan?: () => void;
}

// ─── Message copy by page ─────────────────────────────────────────────────────

function buildMessage(pageContext: NonNullable<Props['pageContext']>, days: number): string {
  const d = `${days} day${days === 1 ? '' : 's'}`;
  switch (pageContext) {
    case 'stats':   return `Your trial ends in ${d}. Advanced Analytics will only be available on the Lead plan.`;
    case 'taxes':   return `Your trial ends in ${d}. Tax Estimation will only be available on the Lead plan.`;
    case 'invoice': return `Your trial ends in ${d}. Invoice Management will only be available on the Lead plan.`;
    default:        return `Your trial ends in ${d}. Subscribe to keep access.`;
  }
}

// ─── Component ────────────────────────────────────────────────────────────────

export function TrialBanner({ pageContext = 'general', onChoosePlan }: Props) {
  const { isTrialing, daysUntilTrialEnd, trialEndsAt } = useSubscription();

  // Show only when actively trialing with ≤5 days left
  if (!isTrialing || daysUntilTrialEnd === null || daysUntilTrialEnd > 5) {
    return null;
  }

  const chargeDate = trialEndsAt
    ? trialEndsAt.toLocaleDateString('en-US', { month: 'short', day: 'numeric' })
    : null;

  const reassurance = chargeDate ? ` Subscribing now won't cut your trial short — you won't be charged until ${chargeDate}.` : '';

  return (
    <div className="w-full bg-black px-6 py-3 flex items-center justify-between">
      <p className="text-[11px] font-bold text-white">
        {buildMessage(pageContext, daysUntilTrialEnd)}{reassurance}
      </p>
      <div className="ml-4 shrink-0">
        <button
          onClick={onChoosePlan}
          className="bg-white text-black rounded-full px-4 py-1.5 text-[10px] font-black uppercase tracking-[0.2em] hover:bg-white/90 transition-colors"
        >
          Choose Plan →
        </button>
      </div>
    </div>
  );
}
